<template>
    <div id="home">

        <b-container class="p-3 v-center">

            <div class="vcentered">
                <div class="text-center p-3" v-if="isLoading">
                    <b-spinner label="Loading..."></b-spinner>
                </div>
                <div class="text-center p-3" v-else-if="isLoaded">
                    <h1>
                        {{ survey.Expedientecontenido.expedienteTemplate.header.expediente_titulo }}
                    </h1>
                    <p>
                        {{ survey.Expedientecontenido.expedienteTemplate.header.expediente_descripcion }}
                        <br>
                        <small>
                            Versión {{ survey.Expedientecontenido.expedienteTemplate.header.version }}.{{
                                survey.Expedientecontenido.expedienteTemplate.header.subversion }}
                        </small>
                    </p>
                    <!-- <b-row align-h="center">
                        <b-img thumbnail src="https://loremflickr.com/640/362" alt="Random Image" fluid />
                    </b-row> -->
                    <hr>
                    <b-button variant="primary" @click="$router.push({ name: 'Survey' })" :disabled="isLoading">
                        <span v-if="isLoading">...</span>
                        <span v-else>Iniciar expediente</span>
                    </b-button>
                </div>
                <div class="text-center p-3" v-else>
                    <b-jumbotron header="No hay datos para mostrar" lead="">
                        <p>Por favor, regrese al sitio principal para más información.</p>
                        <b-button variant="primary" @click="mainSite">
                            Sitio principal
                        </b-button>
                    </b-jumbotron>
                </div>
            </div>

        </b-container>
        <pre class="text-left" v-if="debug">
            <code>
                {{ survey }}
            </code>
        </pre>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { publicWebURI } from '@/apiConfig'
export default {
    name: 'Home',
    props: {
        mainSiteURI: {
            type: String,
            default: () => publicWebURI
        },
        debug: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            isLoading: false
        };
    },
    computed: {
        ...mapGetters(['getSurvey']),
        isLoaded() {
            return this.getSurvey !== null;
        },
        survey() {
            return (this.getSurvey !== null) ? this.getSurvey : null;
        }
    },
    methods: {
        ...mapActions(['fetchData']),
        mainSite() {
            window.location.href = this.mainSiteURI;
        },
        async updateSurvey() {
            this.isLoading = true;
            await this.fetchData({
                id: this.$route.params.id,
                hashKey: this.$route.params.hashKey
            });
            this.isLoading = false;
        }
    },
    beforeMount() {
        this.updateSurvey();
    },
};
</script>